// import Vue from 'vue'
import Vuex from 'vuex'
import assign from 'lodash.assign'
import global from './types/global.types'
import initCourses from './lib/initCourses'

import api from './lib/api'

// 跳转child route会出现模块加载不上的问题，因此在这里注册到全局
import ModuleWealth from './modules/wealth'
import ModuleFreeVideo from './modules/free_video'
import ModulePopup from './modules/popup'
import ModuleMediaCourse from './modules/mediaCourse'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    wealth: ModuleWealth,
    freeVideo: ModuleFreeVideo,
    [ModulePopup.name]: ModulePopup,
    [ModuleMediaCourse.name]: ModuleMediaCourse
  },
  state: {
    launchOptions: {}, // 进入选项
    reachBottomCounter: 0,
    errMessage: [0, ''],
    categories: [],
    courses: [],
    isVip: false,
    redirectFlag: false, // 控制某些页面的重定向以实现相关功能，目前有：购买成功页返回到报名页
    userInfo: {},
    isPrivilege: 1,
    vipOperationList: [],
    durationDays: 0,
    signUpCourseInfo: {},
    organizationMessage: {}
  },
  mutations: {
    set (state, data) {
      assign(state, data)
    },

    signUpCourse (state, data) {
      state.signUpCourseInfo = data
    },

    [global.SET_LAUNCH_OPTIONS] (state, data) {
      state.launchOptions = data
    },

    [global.ERR] (state, payload) {
      assign(state, { errMessage: [++state.errMessage[0], payload] })
    },

    [global.SET_VIP_STATUS] (state, payload) {
      assign(state, { isVip: !!payload })
    },

    [global.CATEGORIES] (state, payload) {
      assign(state, { categories: payload.data, courses: initCourses(payload.data) })
    },

    [global.APPEND_COURSE] (state, payload) {
      const temp = state.courses[payload.index]
      temp.pageNo = payload.pageNo
      temp.list = temp.list.concat(payload.data)
      temp.total = payload.total

      state.courses[payload.index] = temp
    },

    [global.REACH_BOTTOM] (state) {
      state.reachBottomCounter++
    },

    [global.SET_REDIRECT_FLAG] (state) {
      state.redirectFlag = true
    },

    [global.UNSET_REDIRECT_FLAG] (state) {
      state.redirectFlag = false
    }
  },

  actions: {
    async getUserInfo ({ commit }) {
      const { data } = await api.mine.userInfo()
      if (data && data.userid) {
        data.userId = data.userid
        commit('set', { userInfo: data || {} })
      }
    },

    async getPrivilege ({ commit }) {
      try {
        let version = 2
        // let pathName = window.location.pathname
        // if (/(vip-activity)$/.test(pathName)) {
        //   version = 2
        // }
        const { data } = await api.privilege.getPrivilegeInfo(version)()
        commit('set', { isPrivilege: data.isBuy || 0, vipOperationList: data.vipOperationList,  durationDays: data.durationDays})
      } catch (e) {
        console.log(e)
      }
    }
  }
})
